import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import {
  addRequest,
  getRequests,
  getRequestsFilteredByYearAndMonth,
  getRquestNextMonth,
  updateRequest,
  updateRequestStatus,
} from './requests.api';
import { RequestStatusEnum } from '../../common/enums/request-status.enum';
import { IRequestDTO } from '../../common/interfaces/request.interface';

export const useRequestsQuery = (
  company_id: string,
  client_id: string,
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: RequestStatusEnum,
) => {
  return useQuery({
    queryKey: [
      'requests',
      company_id,
      client_id,
      limit,
      page,
      search,
      orderBy,
      orderDirection,
      status,
    ],
    queryFn: () =>
      getRequests(company_id, client_id, limit, page, search, orderBy, orderDirection, status),
  });
};

export const useRequestsFilteredByYearAndMonthQuery = (
  year: string = '',
  month: string = '1',
  limit: number,
  page: number,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: RequestStatusEnum,
) => {
  return useQuery({
    queryKey: ['requests-filtered', year, month, limit, page, orderBy, orderDirection, status],
    queryFn: () =>
      getRequestsFilteredByYearAndMonth(year, month, limit, page, orderBy, orderDirection),
  });
};

export const useRequestNextMonthQuery = (request_id?: number) => {
  return useQuery({
    queryKey: ['requests-next-month', request_id],
    queryFn: request_id ? () => getRquestNextMonth(request_id) : skipToken,
    enabled: !!request_id,
  });
};

export const useAddRequestMutation = () => {
  return useMutation({
    mutationKey: ['request', 'add'],
    mutationFn: (payload: IRequestDTO) => addRequest(payload),
  });
};

export const useUpdateRequestMutation = () => {
  return useMutation({
    mutationKey: ['request', 'update'],
    mutationFn: (payload: IRequestDTO) => updateRequest(payload),
  });
};

export const useUpdateRequestStatusMutation = () => {
  return useMutation({
    mutationKey: ['request', 'update-status'],
    mutationFn: (payload: { id: number; status: RequestStatusEnum }) =>
      updateRequestStatus(payload),
  });
};
